"use client";

import * as React from "react";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { Separator } from "@/components/ui/separator";
const footerLinkColumns = [{
  title: "Services",
  links: [{
    label: "Ride-Hailing",
    href: "/HomePage"
  }, {
    label: "Delivery",
    href: "/HomePage"
  }, {
    label: "Premium Black",
    href: "/HomePage"
  }]
}, {
  title: "Company",
  links: [{
    label: "About Us",
    href: "/HomePage"
  }, {
    label: "Business Solutions",
    href: "/HomePage"
  }, {
    label: "Global Rollout",
    href: "/HomePage"
  }]
}, {
  title: "Legal",
  links: [{
    label: "Privacy Policy",
    href: "/HomePage"
  }, {
    label: "Terms of Service",
    href: "/TermsOfService"
  }, {
    label: "Safety Standards",
    href: "/HomePage"
  }]
}];
export default function ComprehensiveFooter() {
  return <section data-section-id="253310" id="footer" className="bg-white pt-12 pb-8 md:pt-20 md:pb-12 border-t border-border/20 overflow-visible">
      <div className="page-container">
        {}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-6 md:gap-8 lg:gap-12 mb-16">
          {}
          <div className="lg:col-span-2 px-0 md:px-0 min-w-0">
            <Link to="/" className="inline-block mb-6 transition-colors duration-300">
              <WvcLogo className="h-12 w-auto text-foreground" />
            </Link>
            <p className="text-xs text-foreground/90 max-w-xs leading-relaxed font-default">
              Moveonix LLC — Dover, Delaware, USA
            </p>
          </div>

          {}
          {footerLinkColumns.map((column, i) => <div key={i} data-index={i} className="flex flex-col px-0 md:px-0">
              <h3 className="font-semibold text-foreground mb-4 font-default text-xs tracking-widest uppercase">
                {column.title}
              </h3>
              <ul className="space-y-3">
                {column.links.map((link, j) => <li key={j} data-index={j}>
                    <Link to={link.href} className="text-xs text-foreground/80 hover:text-primary transition-colors duration-300 font-default">
                      {link.label}
                    </Link>
                  </li>)}
              </ul>
            </div>)}

          {}
          <div className="flex flex-col px-0 md:px-0">
            <h3 className="font-semibold text-foreground mb-4 font-default text-xs tracking-widest uppercase">
              Contact
            </h3>
            <Link to="mailto:support@moveonix.llc" className="text-xs text-primary hover:text-primary/80 transition-colors duration-300 break-all font-default">
              support@moveonix.llc
            </Link>
          </div>
        </div>

        <Separator className="my-8 bg-border/40" />

        {}
        <div className="mb-8 max-w-5xl px-0 md:px-0 text-left">
          <h4 className="text-xs font-bold text-foreground mb-4 uppercase tracking-widest font-default">
            Regulatory & Safety Notice
          </h4>
          <div className="space-y-4 text-xs text-foreground/80 leading-relaxed font-default">
            <p>
              Moveonix LLC is a technology platform that facilitates transportation and delivery services through its mobile application. We are committed to the highest standards of safety and reliability across all operating regions.
            </p>
            <p className="uppercase font-semibold text-primary">
              OFFICIAL RIDE-HAILING AND LOGISTICS PARTNER. ALL SERVICES ARE SUBJECT TO LOCAL TRANSPORTATION AUTHORITY REGULATIONS AND MOVEONIX SAFETY PROTOCOLS.
            </p>
            <p>
              Service availability varies by region. Please refer to our Global Rollout section for specific information regarding operational status in your country or territory.
            </p>
            <p>
              By using our platform, users and partners agree to comply with all local laws and Moveonix corporate policies. Moveonix LLC maintains comprehensive insurance coverage and rigorous driver vetting processes to ensure a premium experience for every journey.
            </p>
          </div>
        </div>

        <Separator className="my-8 bg-border/40" />

        {}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 text-xs text-foreground/70 font-default px-0 md:px-0">
          <p className="text-left">© 2026 Moveonix LLC. All rights reserved.</p>
          <p className="text-left md:text-right flex items-center gap-2">
            The Concierge of Mobility. 
            <button onClick={() => window.scrollTo({
            top: 0,
            behavior: 'smooth'
          })} className="ml-2 p-1 rounded-lg hover:bg-accent text-primary transition-default" aria-label="Back to top">
              ↑
            </button>
          </p>
        </div>
      </div>
    </section>;
}